import React, { useEffect } from 'react';

import './styles.scss';

import jwt_decode from 'jwt-decode';

import services from '../../../services';

const Home = props => {

  const { nome, token } = services.storage.getUser();
  
  const { role } = jwt_decode(token);

  useEffect(() => {
 
  }, []);

  return (
    <div className="">
      <div className="container">
        <div className="row">
          <div className='col-12'>
            <div className='texto-home'>
              <p>Olá <strong>{ nome }</strong>, você está</p>
              <p>registrado como <strong>Perfil { role }</strong> </p>
            </div>
          </div>
          <div className='col-12'>
          </div>
        </div>
      </div>
    </div>
  );

}

export default Home;